import React from 'react';
import { Input, Label } from 'reactstrap';

class UserDropDown extends React.Component {

    getItems = () => {
        let options = [];

        options = [<option key={0} value={''} disabled>{this.props.dropdownPlaceholder}</option>];
        this.props.users.forEach((user, index) => {
            options.push(<option key={`${this.props.displayName}` + index} value={user.personId}>{user.displayName}</option>);
        });
        return options;
    }

    render() {
        var value = this.props.users.filter(x => x.userId === this.props.value) && this.props.value;
        return (
            <React.Fragment>
                <Label>{this.props.titleToUse}</Label>
                <Input name='userId' type='select' onChange={this.props.onChange} value={value || ''}>
                    {this.getItems()}
                </Input>
            </React.Fragment>
        );
    }
}

export default UserDropDown;